/**
 * Audio Utilities V3 - iOS Compatible
 * Single source of truth: hearenaudio bucket with .m4a files ONLY
 * NO FLAC, NO TRANSCODING, NO FALLBACK
 */

// Audio base URL from hearenaudio public bucket
const AUDIO_BASE_URL = 'https://pub-accb20ccbca0407185b856dee8a7ff7a.r2.dev';

// Audio categories configuration (matches hearenaudio bucket structure)
export const AUDIO_CATEGORIES = {
  classical: { folder: 'Classical', prefix: 'Classical', count: 58 },
  ambient: { folder: 'Ambient', prefix: 'Ambient', count: 43 },
  breathing: { folder: 'BreathingMeditation', prefix: 'Breathing', count: 42 },
  chill: { folder: 'ChillLofi', prefix: 'Chill_lofi', count: 40 },
  nature: { folder: 'Nature', prefix: 'Nature', count: 38 },
  sleep: { folder: 'Sleep', prefix: 'Sleep', count: 46 },
  pulse_flow: { folder: 'PulseFlow', prefix: 'Pulse Flow', count: 41 },
};

/**
 * Get the audio base URL
 */
export const getAudioBaseUrl = () => AUDIO_BASE_URL;

/**
 * Ensure filename has .m4a extension
 * @param {string} filename - Filename with or without extension
 * @returns {string} - Filename with .m4a extension
 */
export const ensureM4aExtension = (filename) => {
  if (!filename || typeof filename !== 'string') {
    return filename;
  }
  
  // Already .m4a
  if (filename.toLowerCase().endsWith('.m4a')) {
    return filename;
  }
  
  // Remove existing extension and add .m4a
  const lastDotIndex = filename.lastIndexOf('.');
  const withoutExt = lastDotIndex > 0 ? filename.substring(0, lastDotIndex) : filename;
  return withoutExt + '.m4a';
};

/**
 * Build audio URL for a file in hearenaudio bucket
 * @param {string} categoryId - Category ID (e.g., 'classical', 'ambient')
 * @param {string} filename - Filename with or without extension
 * @returns {string} - Full URL to audio file
 */
export const buildAudioUrl = (categoryId, filename) => {
  const config = AUDIO_CATEGORIES[categoryId];
  if (!config) {
    console.warn(`Unknown audio category: ${categoryId}`);
    return null;
  }
  
  const folder = config.folder;
  const finalFilename = ensureM4aExtension(filename);
  
  return `${AUDIO_BASE_URL}/${folder}/${finalFilename}`;
};

/**
 * Get list of audio files for a category
 * @param {string} categoryId - Category ID
 * @returns {Array} - List of file objects with url, filename, etc.
 */
export const getCategoryFiles = (categoryId) => {
  const config = AUDIO_CATEGORIES[categoryId];
  if (!config) return [];
  
  const files = [];
  for (let i = 1; i <= config.count; i++) {
    const filename = `${config.prefix}_${String(i).padStart(3, '0')}.m4a`;
    files.push({
      index: i,
      filename,
      url: `${AUDIO_BASE_URL}/${config.folder}/${filename}`,
      category: categoryId
    });
  }
  
  return files;
};

// Legacy export for backward compatibility (will be removed)
export const extToM4a = ensureM4aExtension;

export default { 
  AUDIO_CATEGORIES,
  getAudioBaseUrl,
  ensureM4aExtension,
  buildAudioUrl,
  getCategoryFiles,
  extToM4a
};
